import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const KEY = 'nx_theme';
const LIGHT_ONLY = ['/landing'];
const ThemeContext = createContext({ theme: 'light', isDark: false, toggle: () => {} });

const initialTheme = () => {
  const saved = localStorage.getItem(KEY);
  if (saved === 'light' || saved === 'dark') return saved;
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(initialTheme);
  const { pathname } = useLocation();
  const lightOnly = LIGHT_ONLY.includes(pathname);
  const isDark = theme === 'dark' && !lightOnly;

  useEffect(() => {
    document.documentElement.classList.toggle('dark', isDark);
  }, [isDark]);

  useEffect(() => {
    if (localStorage.getItem(KEY)) return undefined;
    const mq = window.matchMedia?.('(prefers-color-scheme: dark)');
    const onChange = (e) => { if (!localStorage.getItem(KEY)) setTheme(e.matches ? 'dark' : 'light'); };
    mq?.addEventListener?.('change', onChange);
    return () => mq?.removeEventListener?.('change', onChange);
  }, []);

  const toggle = () => setTheme((t) => {
    const next = t === 'dark' ? 'light' : 'dark';
    localStorage.setItem(KEY, next);
    return next;
  });

  return <ThemeContext.Provider value={{ theme, isDark, lightOnly, toggle }}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);
export const useLogo = (lightSrc = '/logo.png') => (useTheme().isDark ? '/logo-dark.png' : lightSrc);
